import React, { useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import hljs from 'highlight.js';
import 'highlight.js/styles/base16/onedark.css';

const Parametri = () => {

	useEffect(() => {
		hljs.highlightAll();
	}, []);
	
const codice1 = `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Document</title>
</head>
<body>
    <!-- Il tag form serve per inviare dei parametri al server. -->
    <!-- L'attributo method specifica GET o POST -->
    <form action="http://127.0.0.1:3000" method="GET">
        <input type="text" name="cognome" id="">
        <input type="submit" id="">
    </form>
</body>
</html>`;

const codice2 = `let http = require("http")
let fs = require("fs")
// const querystring = require('querystring'); // Deprecato!
const querystring = require('url');

http.createServer((req,res)=>{

    //Codice

    let parametro = querystring.parse(req.url,true)
    res.end(parametro.query.cognome)
    //res.end(req.url); // Contiene l'url che il client ha inviato al server

}).listen("3000")`;

  return (
    <div className="container-fluid">
    	<div className="div-intro">
			<div data-aos="fade-right">
			<h1>Passaggio di parametri</h1>
			<hr className="underline" data-aos="fade-right"/>
			</div>
			<br/>
			<div data-aos="fade-right">
			<h4>Come avviene il passaggio di parametri?</h4>
			<p>
Per passare un parametro al server, si utilizza il tag <strong>form</strong>.<br/>
Il tag form si usa infatti quando il client deve inviare dei parametri al server. Al suo interno viene specificato, attraverso l'attributo method, l'invio dei parametri in GET o POST.</p>
			</div>
			<br/><br/>
<div data-aos="fade-right">
<h4>Differenza tra GET e POST</h4>
<p>In <strong>GET</strong> i parametri inviati sono si trovano in chiaro nell'url. Inoltre in GET si ha un limite di caratteri (<i>2.048</i>). In POST invece non esiste un limite di caratteri prefissato e i parametri si trovano all'interno del payload.<br />
In <strong>POST</strong> infatti, il pacchetto è composto dell'header, che contiene informazioni sul comportamento della pagina, mentre nel payload ci sono i parametri in chiaro, che devono essere cifrati con un certificato.</p>
</div>
<br/><br/>
<div data-aos="fade-right">
<h4>Progetto passaggio di parametri (<a href="Progetto_2.zip" target="_blank" download>scarica qui <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-cloud-arrow-down-fill" viewBox="0 0 16 16">
  <path d="M8 2a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 6.095 0 7.555 0 9.318 0 11.366 1.708 13 3.781 13h8.906C14.502 13 16 11.57 16 9.773c0-1.636-1.242-2.969-2.834-3.194C12.923 3.999 10.69 2 8 2m2.354 6.854-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L7.5 9.293V5.5a.5.5 0 0 1 1 0v3.793l1.146-1.147a.5.5 0 0 1 .708.708"/>
</svg></a>)</h4>
<p>Ecco un progetto contentente un esempio di passaggio di parametri al server:</p>
</div>
<div data-aos="zoom-in">
<i>client.html</i>
<pre className="outside-code-toolbar">
<code className="language-html inside-code-toolbar">
{codice1}
</code></pre>
</div>
<div data-aos="zoom-in">
<i>server.js</i>
<pre className="outside-code-toolbar">
<code className="language-javascript inside-code-toolbar">
{codice2}
</code></pre>
</div>
		</div>
    </div>
  );
};

export default Parametri;
